import { useEffect, useState } from 'react';
import { useNavigate, Form } from 'react-router-dom';
import { Table } from 'react-bootstrap';
import classes from './WaitingList.module.css';
import { getApiChara } from '../../../util/getApi';
import { getAuthToken } from '../../../util/auth';
import { toast } from "react-toastify";
import { useContext } from 'react';
import { Button } from "react-bootstrap";
import Loader from '../../UI/Loader';
import WaitingContext from '../../../store/waitingListContext';
import { useTranslation } from "react-i18next";
import ConfirmModal from '../../UI/ConfirmModal';
import Modal from '../../UI/Modal';
import { FaPrint, FaFileExport, FaWhatsapp } from 'react-icons/fa';
import AuthContext from '../../../store/auth-context';
import { printPrescription } from "../Prescriptions/PrescriptionPrint";
import { exportPrescriptionPDF } from "../../../util/pdfExportUtil";
import UpcomingAppointmentsModal from "../../UI/UpcomingAppointmentsModal";

const WaitingList = (props) => {
  const { t } = useTranslation();
  const navigate = useNavigate();
  const authCtx = useContext(AuthContext);
  const wPContext = useContext(WaitingContext);
  const [waitingData, setWaitingData] = useState([]);
  const [deletePatient, setIsDeletedPatient] = useState([]);
  const [downPatient, setDownPatient] = useState([]);
  const [doctorData, setdoctorData] = useState([]);
  const [filteredWaitingByDr, setFilteredWaitingByDr] = useState([]);
  const [sortOrder, setSortOrder] = useState('asc');
  const [isLoading, setIsLoading] = useState(false);
  const [searchInput, setSearchInput] = useState('');
  const [selectedDate, setSelectedDate] = useState("");
  const [openDropdownIndex, setOpenDropdownIndex] = useState(null);
  const [showConfirmModal, setShowConfirmModal] = useState(false);
  const [patientToDelete, setPatientToDelete] = useState(null);
  const [showVitalsModal, setShowVitalsModal] = useState(false);
  const [showUpcomingModal, setShowUpcomingModal] = useState(false);

  const handleToggleDropdown = (index) => {
    // setOpenDropdownIndex(openDropdownIndex === index ? null : index);
    setOpenDropdownIndex((prevIndex) => (prevIndex === index ? null : index));
  };
  const handleSearch = (e) => {
    setSearchInput(e.target.value);
  };

  useEffect(() => {
    fetchDoctorList();
    fetchWaitingData();
  }, [props.patientData, deletePatient, downPatient]);
  useEffect(() => {
    const filteredData = waitingData.filter((waitingp) => {
      const fullName =
        waitingp.patientId.firstName +
        ' ' +
        waitingp.patientId.middleName +
        ' ' +
        waitingp.patientId.lastName;

      return fullName.toLowerCase().includes(searchInput.toLowerCase());
    });

    setFilteredWaitingByDr(filteredData);
  }, [searchInput, waitingData]);
  const fetchDoctorList = async () => {
    const token = getAuthToken();
    if (token === null || token === 'EXPIRED') {
      navigate('/');
    }
    const apiChar = getApiChara();
    const apiUrl = `${apiChar}/users/getDoctorsList`;
    setIsLoading(true);
    try {
      const response = await fetch(apiUrl, {
        headers: {
          Authorization: "Bearer " + token,
        },
      });

      if (!response.ok) {
        throw new Error("Could Not fetch doctor details");
      }
      const doctorData = await response.json();
      setdoctorData(doctorData);
    } catch (error) {
      const errMsg = t("Server is offline");
      const errDesc = t("check your internet connection");
      navigate(`/access-denied?errorCode=500&errorMessage=${encodeURIComponent(errMsg)}&errorDescription=${encodeURIComponent(errDesc)}`);
    }
    finally {
      setIsLoading(false);
    }
  };
  const onSelectDoctorHandler = (e) => {
    const selectedId = parseInt(e.target.value);

    let filtered = [...waitingData];

    // ✅ Date filter still applied
    if (selectedDate) {
      filtered = filtered.filter(
        (waitingp) =>
          waitingp.appointmentTime?.split(" ")[0] === selectedDate
      );
    }

    if (selectedId !== 0) {
      filtered = filtered.filter(
        (waitingp) => waitingp.doctorId.userId === selectedId
      );
    }

    setFilteredWaitingByDr(filtered);
  };

  const fetchWaitingData = async () => {
    const token = getAuthToken();
    if (token === null || token === 'EXPIRED') {
      navigate('/');
    }
    const apiChar = getApiChara();
    const apiUrl = `${apiChar}/waitingList/getTodaysAllPatient`;
    setIsLoading(true);
    try {
      const response = await fetch(apiUrl, {
        headers: {
          Authorization: "Bearer " + token,
        },
      });

      if (!response.ok) {
        throw new Error("Could Not fetch details");
      }

      const data = await response.json();
      const sortedBySerialNo = (data || []).sort((a, b) => (Number(a.serialNo) || 0) - (Number(b.serialNo) || 0));
      setWaitingData(sortedBySerialNo);
      setFilteredWaitingByDr(sortedBySerialNo);
      props.getWaitingList(sortedBySerialNo);
    } catch (error) {
      console.error("Error fetching waiting list data: ", error);
      const errMsg = t("Server is offline");
      const errDesc = t("check your internet connection");
      navigate(`/access-denied?errorCode=500&errorMessage=${encodeURIComponent(errMsg)}&errorDescription=${encodeURIComponent(errDesc)}`);
    }
    finally {
      setIsLoading(false);
    }
  };
  const fetchWaitingDataByDate = async () => {
    if (!selectedDate) return toast.error(t("Please select a date"));

    const token = getAuthToken();
    if (token === null || token === "EXPIRED") {
      navigate("/");
    }

    const apiChar = getApiChara();
    const apiUrl = `${apiChar}/waitingList/getWaitingListPatientByDate?date=${selectedDate}`;

    setIsLoading(true);

    try {
      const response = await fetch(apiUrl, {
        headers: {
          Authorization: "Bearer " + token,
        },
      });

      if (!response.ok) {
        throw new Error("Could not fetch date-wise data");
      }

      const data = await response.json();
      const sortedBySerialNo = (data || []).sort((a, b) => (Number(a.serialNo) || 0) - (Number(b.serialNo) || 0));

      setWaitingData(sortedBySerialNo);
      setFilteredWaitingByDr(sortedBySerialNo);

      props.getWaitingList(sortedBySerialNo);
    } catch (error) {
      console.error("Error fetching waiting list by date: ", error);
      toast.error(t("Unable to load date-wise data"));
    } finally {
      setIsLoading(false);
    }
  };

  const removePatientFromWaiting = (e, waitingp) => {
    e.preventDefault();
    setPatientToDelete(waitingp);
    setShowConfirmModal(true);
  };

  const confirmDeleteHandler = async () => {
    if (!patientToDelete) return;

    const waitingp = patientToDelete;
    const patientName = `${waitingp?.patientId?.firstName} ${waitingp?.patientId?.lastName}`;
    const token = getAuthToken();
    const apiChar = getApiChara();

    // Extract only the ID from the waiting list object
    const waitingListId = waitingp?.waitingListId;
    const fetchApi = `${apiChar}/waitingList/deleteWaitingList/${waitingListId}`;

    setIsLoading(true);
    try {
      const response = await fetch(fetchApi, {
        method: "DELETE",
        headers: {
          Authorization: "Bearer " + token,
        },
      });

      if (!response.ok) {
        throw new Error("Network response was not ok");
      }

      const message = await response.text(); // backend is sending plain text
      toast.success(
        t("Patient {{name}} removed from waiting list.", { name: patientName })
      );

      // Pass the original waiting object for UI updates
      setIsDeletedPatient(waitingp);
    } catch (error) {
      console.error("Error deleting waiting list entry: ", error);
      toast.error(t("Patient could not be deleted"));
      const errMsg = t("Server is offline");
      const errDesc = t("check your internet connection");
      navigate(`/access-denied?errorCode=500&errorMessage=${encodeURIComponent(errMsg)}&errorDescription=${encodeURIComponent(errDesc)}`);
    } finally {
      setIsLoading(false);
    }
  };

  const upPatientFromWaiting = async (e, waitingp) => {
    e.preventDefault();

    if (filteredWaitingByDr.length <= 1) {
      toast.info(t("Waiting list has only one patient. Cannot move up or down."));
      return;
    }

    const token = getAuthToken();
    const apiChar = getApiChara();
    const fetchApi = `${apiChar}/waitingList/updateWaitingListUp`;
    setIsLoading(true);

    try {
      const response = await fetch(fetchApi, {
        method: "put",
        body: JSON.stringify(waitingp),
        headers: {
          "Content-Type": "application/json",
          authorization: "Bearer " + token,
        },
      });

      if (!response.ok) {
        throw new Error("Network response was not ok");
      }

      const data = response;
      toast.success(t("Waiting number changed"));
      setDownPatient(data);
    } catch (error) {
      console.error("There has been a problem with your fetch operation:", error);
      toast.error(t("Waiting number not get updated"));
    } finally {
      setIsLoading(false);
    }
  };

  const downPatientFromWaiting = async (e, waitingp) => {
    e.preventDefault();

    if (filteredWaitingByDr.length <= 1) {
      toast.info(t("Waiting list has only one patient. Cannot move up or down."));
      return;
    }

    const token = getAuthToken();
    const apiChar = getApiChara();
    const fetchApi = `${apiChar}/waitingList/updateWaitingListDown`;
    setIsLoading(true);

    try {
      const response = await fetch(fetchApi, {
        method: "put",
        body: JSON.stringify(waitingp),
        headers: {
          "Content-Type": "application/json",
          authorization: "Bearer " + token,
        },
      });

      if (!response.ok) {
        throw new Error("Network response was not ok");
      }

      const data = response;
      toast.success(t("Waiting number changed"));
      setDownPatient(data);
    } catch (error) {
      console.error("There has been a problem with your fetch operation:", error);
      toast.error(t("Waiting number not get updated"));
    } finally {
      setIsLoading(false);
    }
  };

  const fetchCheckUpRecord = async (waitingListId) => {
    const token = getAuthToken();
    const apiChar = getApiChara();
    const fetchApi = `${apiChar}/checkUp/getCheckUpRecordByWaitingListId?id=${waitingListId}`;

    try {
      const response = await fetch(fetchApi, {
        headers: {
          authorization: "Bearer " + token,
        },
      });
      if (!response.ok) {
        throw new Error("Failed to fetch checkup record");
      }
      return await response.json();
    } catch (error) {
      console.error("Error fetching checkup record:", error);
      return null;
    }
  };

  const handleActionPrint = async (waitingp) => {
    const isSentToDoctor = waitingp?.checkUpStatus === "CHECK_UP" || waitingp?.checkUpStatus === "SEND_INSIDE";
    const isFuture = isFutureAppointment(waitingp?.appointmentTime);

    if (!isSentToDoctor && !isFuture) {
      setShowVitalsModal(true);
      return;
    }

    setIsLoading(true);
    const data = await fetchCheckUpRecord(waitingp.waitingListId);
    setIsLoading(false);

    // If no checkup data found, still allow printing with empty vitals
    const vitals = {
      weight: data?.weight || "-",
      bps: data?.bp1 || "-",
      bpd: data?.bp2 || "",
      pulse: data?.pulse || "-",
      temp: data?.temperature || "-",
      spo2: data?.spo2 || "-",
      lmp: data?.lmp || data?.Lmp || null,
      edd: data?.edd || data?.Edd || null,
      length: data?.length || "",
      hc: data?.hc || "",
      diagnosis: data?.diagnosis || null,
      complaint: data?.complaint || null
    };

    // Use authCtx.hospitalData for branding to ensure header appears
    const brandingData = {
      ...authCtx.hospitalData,
      // If the record has a specific doctor, use it
      doctorName: waitingp.doctorId
        ? `${waitingp.doctorId.firstName} ${waitingp.doctorId.lastName}`
        : authCtx.hospitalData.doctorName
    };

    printPrescription(
      { patientId: waitingp.patientId },
      [],
      brandingData,
      vitals,
      data?.dateTime || new Date().toISOString(),
      authCtx,
      true
    );
  };

  const handleActionExport = async (waitingp) => {
    const isSentToDoctor = waitingp?.checkUpStatus === "CHECK_UP" || waitingp?.checkUpStatus === "SEND_INSIDE";
    const isFuture = isFutureAppointment(waitingp?.appointmentTime);

    if (!isSentToDoctor && !isFuture) {
      setShowVitalsModal(true);
      return;
    }

    setIsLoading(true);
    const data = await fetchCheckUpRecord(waitingp.waitingListId);
    setIsLoading(false);

    const vitals = {
      weight: data?.weight || "-",
      bps: data?.bp1 || "-",
      bpd: data?.bp2 || "",
      pulse: data?.pulse || "-",
      temp: data?.temperature || "-",
      spo2: data?.spo2 || "-",
      lmp: data?.lmp || data?.Lmp || null,
      edd: data?.edd || data?.Edd || null,
      length: data?.length || "",
      hc: data?.hc || "",
      diagnosis: data?.diagnosis || null,
      complaint: data?.complaint || null
    };

    exportPrescriptionPDF({
      patientData: { patientId: waitingp.patientId },
      medicines: [],
      checkedData: vitals,
      authCtx: authCtx, // authCtx already used inside exportPrescriptionPDF for hospitalData
      selectedDateTime: data?.dateTime || new Date().toISOString(),
      reportTitle: t("Case Paper")
    });
  };

  const toGetInsideForCheckup = (e, waitingp) => {
    e.preventDefault();
    wPContext.OnAddedcheckUp(waitingp);
    navigate('getinside');
  }
  const handleSort = () => {
    const sortedData = [...filteredWaitingByDr];

    // Toggle the sort order
    const newSortOrder = sortOrder === 'asc' ? 'desc' : 'asc';

    // Sort the data based on the "Sr No" column
    sortedData.sort((a, b) => {
      const comparison = (Number(a.serialNo) || 0) - (Number(b.serialNo) || 0);
      return sortOrder === 'asc' ? comparison : -comparison;
    });

    // Update the state with the sorted data and sort order
    setFilteredWaitingByDr(sortedData);
    setSortOrder(newSortOrder);
  };

  const isFutureAppointment = (appointmentTime) => {
    if (!appointmentTime) return false;
    const datePart = appointmentTime.split(" ")[0];
    const [year, month, day] = datePart.split("-").map(Number);
    const apptDate = new Date(year, month - 1, day); // Parse as local date
    const today = new Date();
    today.setHours(0, 0, 0, 0);
    return apptDate.getTime() > today.getTime();
  };

  const handleWhatsAppReminder = (waitingp) => {
    const patientMobile = waitingp?.patientId?.mobile || "";
    const patientName = `${waitingp?.patientId?.firstName || ""} ${waitingp?.patientId?.lastName || ""}`.trim() || t("Patient");
    const doctorName = waitingp?.doctorId?.firstName && waitingp?.doctorId?.lastName
      ? `${waitingp.doctorId.firstName} ${waitingp.doctorId.lastName}`
      : authCtx.hospitalData?.doctorName || "";
    const hospitalName = authCtx.hospitalData?.hospitalName || "";
    const appointmentTime = waitingp?.appointmentTime || "";

    if (!patientMobile) {
      toast.error(t("Mobile number not available"));
      return;
    }

    const cleanMobile = patientMobile.replace(/\D/g, '');
    const message = t("Dear {{patientName}}, this is a reminder for your appointment with Dr. {{doctorName}} on {{appointmentTime}} at {{hospitalName}}. Regards, {{hospitalName}}", {
      patientName: patientName,
      doctorName: doctorName,
      appointmentTime: appointmentTime,
      hospitalName: hospitalName
    });

    const waUrl = `https://wa.me/91${cleanMobile}?text=${encodeURIComponent(message)}`;
    window.open(waUrl, "_blank");
  };
  useEffect(() => {
    let filtered = [...waitingData];

    // 🔍 search filter
    filtered = filtered.filter((waitingp) => {
      const fullName = `${waitingp.patientId.firstName} ${waitingp.patientId.middleName ?? ''} ${waitingp.patientId.lastName}`
        .trim()
        .toLowerCase();
      return fullName.includes(searchInput.toLowerCase());
    });

    // 👨‍⚕️ doctor filter
    const selectedId = document.getElementById("DoctName")?.value;
    if (selectedId && selectedId !== "0") {
      filtered = filtered.filter(
        (waitingp) => waitingp.doctorId.userId === Number(selectedId)
      );
    }

    // ❌ removed date filter (only arrow button should filter)

    setFilteredWaitingByDr(filtered);
  }, [searchInput, waitingData]); // ❌ removed selectedDate

  useEffect(() => {
    const today = new Date();
    const yyyy = today.getFullYear();
    const mm = String(today.getMonth() + 1).padStart(2, '0');
    const dd = String(today.getDate()).padStart(2, '0');

    setSelectedDate(`${yyyy}-${mm}-${dd}`);
  }, []);
  return (
    <>
      {isLoading && <Loader />}
      <div className={classes.coverp}>
        <div className='container-fluid px-3'>
          <div className="d-flex align-items-center mb-3 flex-wrap">
            <div className="d-none d-md-block" style={{ flex: 1 }}></div>
            <h4 className={classes.headerPremium} style={{ margin: 0, flex: 'none' }}>{t("Waiting List")}</h4>
            <div className="ms-auto" style={{ flex: 1, display: 'flex', justifyContent: 'flex-end' }}>
              <button
                className="btn d-flex align-items-center gap-2"
                onClick={() => setShowUpcomingModal(true)}
                style={{
                  backgroundColor: '#FFA500', // Orange as in screenshot
                  color: 'white',
                  fontWeight: '600',
                  padding: '0.6rem 1.25rem',
                  borderRadius: '8px',
                  border: 'none',
                  boxShadow: '0 4px 6px rgba(0,0,0,0.1)',
                  textTransform: 'uppercase',
                  fontSize: '0.85rem',
                  transition: 'all 0.3s ease'
                }}
                onMouseOver={(e) => e.currentTarget.style.transform = 'translateY(-2px)'}
                onMouseOut={(e) => e.currentTarget.style.transform = 'translateY(0)'}
              >
                <i className="fa fa-calendar-check-o"></i> {t("Upcoming Follow-ups")}
              </button>
            </div>
          </div>
          <div className='row mb-3 g-2 align-items-center'>
            {/* Row 1: Date */}
            <div className="col-12 col-md-4">
              <div className="d-flex align-items-center">
                <label className="me-2 mb-0 text-nowrap fw-bold text-secondary small" style={{ fontSize: '11px' }}>{t("Date:")}</label>
                <div className="input-group flex-nowrap">
                  <input
                    id="dateFilter"
                    type="date"
                    className={classes.formControlModern}
                    value={selectedDate}
                    onChange={(e) => setSelectedDate(e.target.value)}
                    style={{ borderTopRightRadius: '0 !important', borderBottomRightRadius: '0 !important', borderRight: 'none', flex: 1, fontSize: '12px', height: '34px' }}
                  />
                  <button className={classes.arrowBtn} type="button" onClick={fetchWaitingDataByDate} style={{ height: '34px', padding: '0 12px' }}>
                    <i className="fa fa-arrow-right"></i>
                  </button>
                </div>
              </div>
            </div>

            {/* Row 2: Search */}
            <div className='col-6 col-md-4'>
              <div className="d-flex align-items-center">
                <input
                  id="search"
                  type="text"
                  className={classes.formControlModern}
                  value={searchInput}
                  onChange={handleSearch}
                  placeholder={t("Search...")}
                  style={{ fontSize: '12px', height: '34px' }}
                />
              </div>
            </div>

            {/* Row 3: Doctor */}
            <div className='col-6 col-md-4'>
              <div className="d-flex align-items-center">
                <select
                  id="DoctName"
                  name="DoctName"
                  className={classes.selectModern}
                  onChange={onSelectDoctorHandler}
                  required
                  style={{ fontSize: '12px', height: '34px' }}
                >
                  <option value="0">{t("All Doctors")}</option>
                  {doctorData.map((doctor) => (
                    <option key={doctor.userId} value={doctor.userId}>
                      {doctor.firstName} {doctor.lastName}
                    </option>
                  ))}
                </select>
              </div>
            </div>
          </div>
        </div>
        <div className={`boxes table-responsive ${classes.waitingTableContainer}`}>
          <Table striped bordered hover>
            <thead>
              <tr>
                <th onClick={handleSort}>{t("Sr. No.")} <i className='fa fa-sort'></i></th>
                <th>{t("Name")}</th>
                <th>{t("Mobile")}</th>
                <th>{t("Appointment")}</th>
                <th>{t("Doctor")}</th>
                <th>{t("Take Vitals")}</th>
                <th>{t("Actions")}</th>
              </tr>
            </thead>
            <tbody>
              {filteredWaitingByDr.length === 0 && (
                <tr>
                  <td colSpan="8" className='text-center'>
                    <p className='background-transparent'>{t("No Record found")}</p>
                  </td>
                </tr>
              )}
              {filteredWaitingByDr.map((waitingp, index) => (
                <tr key={waitingp?.waitingListId}
                  className={`${(waitingp?.checkUpStatus === "CHECK_UP" || waitingp?.checkUpStatus === "SEND_INSIDE") ? classes.greenBackground : ''}`}
                >
                  <td>{waitingp?.serialNo}</td>
                  <td>
                    {`${waitingp?.patientId?.firstName || ""} ${waitingp?.patientId?.middleName ? waitingp.patientId.middleName + " " : ""}${waitingp?.patientId?.lastName || ""}`.trim()}
                  </td>
                  <td>{waitingp?.patientId?.mobile || "-"}</td>
                  <td> {waitingp?.appointmentTime}</td>
                  <td>{waitingp?.doctorId?.firstName && waitingp?.doctorId?.lastName
                    ? `${waitingp.doctorId.firstName} ${waitingp.doctorId.lastName}`
                    : "-"}</td>
                  <td>
                    <form
                      onSubmit={(e) => toGetInsideForCheckup(e, waitingp)}
                    >
                      {/* <button className="btn btn-link" type="submit">
                     Check Up
                    </button> */}
                      <Button
                        size="sm"
                        className={`btn button-sm ${waitingp?.checkUpStatus === "CHECK_UP" || waitingp?.checkUpStatus === "SEND_INSIDE" ? classes.disabledBtn : ""}`}
                        type="submit"
                        disabled={waitingp?.checkUpStatus === "CHECK_UP" || waitingp?.checkUpStatus === "SEND_INSIDE" || isFutureAppointment(waitingp?.appointmentTime)}
                        title={waitingp?.checkUpStatus === "CHECK_UP" || waitingp?.checkUpStatus === "SEND_INSIDE" ? t("Already sent to doctor") : ""}
                      >
                        {waitingp?.checkUpStatus === "CHECK_UP" || waitingp?.checkUpStatus === "SEND_INSIDE"
                          ? <span><i className="fa fa-check me-1"></i> {t("Sent to Doctor")}</span>
                          : t("Send to Doctor")}
                      </Button>
                    </form>
                  </td>
                  <td>
                    <div className="d-flex gap-1 justify-content-center">
                      <Button
                        variant="outline-primary"
                        size="sm"
                        className="btn-outline-premium"
                        onClick={(e) => upPatientFromWaiting(e, waitingp)}
                        title={t("Move Up")}
                        style={{ padding: '0.25rem 0.5rem' }}
                      >
                        <i className="fa fa-arrow-up"></i>
                      </Button>
                      <Button
                        variant="outline-secondary"
                        size="sm"
                        className="btn-outline-secondary-premium"
                        onClick={(e) => downPatientFromWaiting(e, waitingp)}
                        title={t("Move Down")}
                        style={{ padding: '0.25rem 0.5rem' }}
                      >
                        <i className="fa fa-arrow-down"></i>
                      </Button>

                      <Button
                        variant="outline-info"
                        size="sm"
                        className="btn-outline-info-premium text-white"
                        onClick={() => handleActionPrint(waitingp)}
                        title={t("Print Case Paper")}
                        style={{ padding: '0.25rem 0.5rem', backgroundColor: '#0d6efd', borderColor: '#0d6efd' }}
                      >
                        <FaPrint />
                      </Button>
                      <Button
                        variant="outline-info"
                        size="sm"
                        className="btn-outline-info-premium text-white"
                        onClick={() => handleActionExport(waitingp)}
                        title={t("Export Case Paper")}
                        style={{ padding: '0.25rem 0.5rem', backgroundColor: '#17a2b8', borderColor: '#17a2b8' }}
                      >
                        <FaFileExport />
                      </Button>

                      {isFutureAppointment(waitingp?.appointmentTime) && (
                        <Button
                          variant="outline-success"
                          size="sm"
                          className="btn-outline-success-premium text-white"
                          onClick={() => handleWhatsAppReminder(waitingp)}
                          title={t("Send WhatsApp Reminder")}
                          style={{ padding: '0.25rem 0.5rem', backgroundColor: '#25D366', borderColor: '#25D366' }}
                        >
                          <FaWhatsapp />
                        </Button>
                      )}

                      <Button
                        variant="outline-danger"
                        size="sm"
                        className="btn-outline-danger-premium"
                        onClick={(e) => removePatientFromWaiting(e, waitingp)}
                        title={t("Delete")}
                        style={{ padding: '0.25rem 0.5rem' }}
                      >
                        <i className="fa fa-trash-o"></i>
                      </Button>
                    </div>
                  </td>
                </tr>
              ))}
            </tbody>
          </Table>
        </div>
      </div >
      <ConfirmModal
        show={showConfirmModal}
        onHide={() => setShowConfirmModal(false)}
        onConfirm={confirmDeleteHandler}
        title={t("Delete Patient")}
        message={t("Are you sure you want to remove {{name}} from the waiting list?", {
          name: patientToDelete ? `${patientToDelete?.patientId?.firstName} ${patientToDelete?.patientId?.lastName}` : ""
        })}
        variant="danger"
        isLoading={isLoading}
      />
      {showVitalsModal && (
        <Modal
          title={t("Vital Signs Check")}
          message={t("Send the patient to the doctor first. Case paper printing is allowed only afterward.")}
          OnConfirmBlock={() => setShowVitalsModal(false)}
        />
      )}
      <UpcomingAppointmentsModal
        show={showUpcomingModal}
        onHide={() => setShowUpcomingModal(false)}
        hospitalName={authCtx.hospitalData?.hospitalName}
        doctorName={authCtx.hospitalData?.doctorName}
      />
    </>
  );
};

export default WaitingList;